import { Typography, type TypographyProps } from "~/common/mui";
import LabelBox from "~/domains/salesCampaign/components/LabelBox/LabelBox";
import { type PriceData } from "~/domains/pricing/types/PriceData";
import { NumberFormatter as NF } from "~/common/utils/NumberFormatter";

interface Props {
  className?: string;
  soldOut?: boolean;
  regularPrice?: PriceData | null;
  salePrice?: PriceData;
}

export const SaleDiscountIndicator = ({ soldOut, className, regularPrice, salePrice }: Props) => {
  const r = regularPrice?.value ?? 0;
  const s = salePrice?.value ?? 0;
  if (!r || !s) {
    return null;
  }
  const diff = r - s;
  if (diff <= 0) {
    return null;
  }

  const discountPercent = Math.round((diff / r) * 100);
  // TODO - Uhm, weight formatter? Let's name it differently
  const label = `-${NF.getWeightFormatterG().format(discountPercent)}%`;

  const color = soldOut ? "inactive" : "active";
  return (
    <LabelBox variant={color} className={className}>
      {label}
    </LabelBox>
  );
};

type V2Props = Props &
  Pick<TypographyProps, "variant" | "sx"> & {
    discountFormatted: string | null;
  };

const V2 = ({ discountFormatted, variant, soldOut, sx: externalSx, ...rest }: V2Props) => {
  if (!discountFormatted) {
    return null;
  }
  const color = soldOut ? "disabled" : "salesCampaign";
  const sx = {
    fontWeight: 500,
    ...externalSx,
  };
  return (
    <Typography variant={variant} color={color} sx={sx} {...rest}>
      {discountFormatted}
    </Typography>
  );
};

SaleDiscountIndicator.V2 = V2;
